<template>
  <div class="list">
    <div class="topBar">
      <div class="subTitle">
        <i class="far fa-window-minimize" style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"></i>
        bioflinnews详情
        <!-- <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
        </div>-->
        <!-- <div style="margin-left:4px" @click="geting()">返回</div> -->
        <!-- </div> -->
      </div>
    </div>
    <div class="center">
      <div class="audit">
        <div class="audit_div">
          <p class="audit_div_p1">论文题目:</p>
          <p class="audit_div_p2">{{title}}</p>
        </div>
        <div class="audit_div1">
          <p class="audit_div_p1">内容摘要:</p>
          <p class="audit_div_p2">{{abstract}}</p>
        </div>
        <div class="audit_div">
          <p class="audit_div_p1">　　作者:</p>
          <p class="audit_div_p2">{{writer}}</p>
        </div>
        <div class="audit_div">
          <p class="audit_div_p1">详细内容:</p>
          <p class="audit_div_icon" @click="browse()">
            <i class="fas fa-cloud-download-alt"></i>
            下载到本地
          </p>
          <p class="audit_div_p3">
            在线预览
            <!-- <iframe src="" frameborder="0"></iframe>
            -->
            <!-- <a href=this.serve+"/bioflinnews/bioflinnews3.docx">在线预览</a> -->
          </p>
        </div>
        <div class="audit_div" style="margin-top:80px;">
          <el-button
            type="danger"
            @click="passNo()"
            style="margin-left: 76px;"
            :disabled="show"
          >拒绝通过</el-button>
          <el-button @click="pass()" type="success" style="margin-left: 20px;" :disabled="show">通过审核</el-button>
        </div>
      </div>
    </div>
    <!-- 添加用户 -->
  </div>
</template>

<script>
export default {
  data() {
    return { serve: this.$store.state.serve,
      show: false,
      token: "",
      username: "",
      tableData: [],
      id: this.$route.params.id,
      title: "",
      abstract: "",
      writer: "",
      text_file: "",
      URL: ""
    };
  },
  created() {
    this.$store.state.topActiveId = 4;
    this.$store.state.leftTitle = "bioflinnews审核";
    this.token = this.$cookies.get("token");
    this.username = this.$cookies.get("username");
    const _this = this;
    this.axios
      .get(this.serve+"/admin/bioflinnews_detail", {
        params: {
          username: this.username,
          token: this.token,
          id: this.id
        }
      })
      .then(res => {
        if (res.data.status == "success") {
          var json = res.data.data;
          _this.title = json.title;
          _this.abstract = json.abstract;
          _this.writer = json.writer;
          _this.text_file = json.text_file;
          if (json.status != 0) {
            this.show = true;
          }
        }
      });
  },
  methods: {
    browse() {
      if (this.text_file != null) {
        const _this = this;
        this.axios
          .get(this.serve+"/admin/download_bioflinnews", {
            params: {
              username: this.username,
              token: this.token,
              id: this.id,
              title: this.title,
              bioflinnews: this.text_file
            }
          })
          .then(res => {
            window.location.href = res.request.responseURL;
          });
      }
    },
    pass() {
      const loading = this.$loading({
        lock: true,
        text: "正在上传",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const _this = this;
      this.axios
        .get(this.serve+"/admin/check_bioflinnews", {
          params: {
            username: this.username,
            token: this.token,
            id: this.id,
            res: 1
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            loading.close();
            _this.$router.push({ path: "y_audit" });
          }
        })
        .catch(err => {
          alert("操作失败");
        });
    },

    passNo() {
      const loading = this.$loading({
        lock: true,
        text: "正在上传",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const _this = this;
      this.axios
        .get(this.serve+"/admin/check_bioflinnews", {
          params: {
            username: this.username,
            token: this.token,
            id: this.id,
            res: 2
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            loading.close();
            _this.$router.push({ path: "y_audit" });
          }
        })
        .catch(err => {
          alert("操作失败");
        });
    }
  }
};
</script>
<style lang="scss">
.list {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .center {
    width: 1056px;
    // height: 560px;
    background: #fff;
    margin: 0 auto;
    .audit {
      width: 40%;
      margin: 0 auto;
      padding-top: 30px;
      //   text-align: center;
    }
    .audit_div1 {
      display: flex;
      margin-bottom: 10px;
      .audit_div_p1 {
        font-size: 14px;
        font-family: "MicrosoftYaHeiLight";
        font-weight: 300;
        color: rgba(51, 51, 51, 1);
        padding-top: 4px;
      }
      .audit_div_p2 {
        margin-left: 15px;
        font-size: 16px;
        font-family: "MicrosoftYaHei";
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        width: 340px;
      }
    }
    .audit_div {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      .audit_div_icon {
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        color: #c0c4cc;
        display: inline-block;
        font-size: inherit;
        height: 40px;
        line-height: 40px;
        width: 190px;
        padding-left: 10px;
        margin-left: 15px;
        cursor: pointer;
      }
      .audit_div_p1 {
        font-size: 14px;
        font-family: "MicrosoftYaHeiLight";
        font-weight: 300;
        color: rgba(51, 51, 51, 1);
      }
      .audit_div_p2 {
        margin-left: 15px;
        font-size: 16px;
        font-family: "MicrosoftYaHei";
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        width: 340px;
      }
      .audit_div_p3 {
        margin-left: 4px;
        font-size: 12px;
        font-family: "MicrosoftYaHeiLight";
        font-weight: 300;
        color: rgba(153, 153, 153, 1);
        cursor: pointer;
      }
      .audit_div_p3:hover {
        color: rgba(51, 51, 51, 1);
      }
    }
  }
}
</style>